"use client";

import React, { useState } from "react";
import { addDays, format } from "date-fns";
import { Calendar as CalendarIcon, Trash } from "lucide-react";

import { cn } from "../../Lib/utils";
import { Button } from "./button";
import { Calendar } from "./calender";
import { Popover, PopoverContent, PopoverTrigger } from "./popover";

export function DatePickerWithRange({ className, date, setDate }) {
  const today = new Date();
  // const [date, setDate] = useState({
  //   from: today,
  //   to: today,
  // });
  return (
    <div className={cn("grid gap-2", className)}>
      <Popover>
        <PopoverTrigger asChild>
          <Button
            id='date'
            variant={"outline"}
            className={cn(
              "w-[300px] justify-start text-left font-normal",
              !date && "text-muted-foreground"
            )}
          >
            <CalendarIcon className='mr-2 h-4 w-4' />
            {date?.from ? (
              date.to ? (
                <>
                  {format(date.from, "LLL dd, y")} -{" "}
                  {format(date.to, "LLL dd, y")}
                </>
              ) : (
                format(date.from, "LLL dd, y")
              )
            ) : (
              <span>Pick a date</span>
            )}
          </Button>
        </PopoverTrigger>
        <PopoverContent className='bg-bgGreen w-auto p-0' align='start'>
          <Calendar
            initialFocus
            mode='range'
            defaultMonth={date?.from}
            selected={date}
            onSelect={setDate}
            numberOfMonths={1}
            disabled={{ after: today }}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
}
